import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PQRCargaHorarioEnsinoDto } from '../../dtos';
import { DadosTabelaCargaHoraria } from '../../components/carga-horaria-de-ensino/carga-horaria-de-ensino.component';

@Component({
  selector: 'app-dialog-pqr-padrao-carga-horaria',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, NgFor, NgIf, TabelaComponent],
  templateUrl: './dialog-pqr-padrao-carga-horaria.component.html',
  styleUrl: './dialog-pqr-padrao-carga-horaria.component.scss',
})
export class DialogPqrPadraoCargaHorariaComponent {
  @Input() dadosTabelaDto: PQRCargaHorarioEnsinoDto[] = [];
  dadosTabelaViewModel: DadosTabelaCargaHoraria[] = [];
  catalogoEtapa: any = {
    '1': {
      id: 1,
      descricao: 'Creche'
    },
    '2': {
      id: 1,
      descricao: 'Pré-Escola'
    },
    '3': {
      id: 1,
      descricao: 'Ensino Fundamental - anos iniciais'
    },
    '4': {
      id: 1,
      descricao: 'Ensino Fundamental - anos finais'
    },
    '5':
    {
      id: 1,
      descricao: 'Ensino Médio'
    },
    '6': {
      id: 1,
      descricao: 'EJA'
    }
  };

  ngOnInit() {
    this.transformDadosTabela(this.dadosTabelaDto);
  }

  transformDadosTabela(dadosTabela: PQRCargaHorarioEnsinoDto[]) {
    this.dadosTabelaViewModel = [];
    const agrupamentoPorEtapaEnsino = dadosTabela.reduce((result: any, item: PQRCargaHorarioEnsinoDto) => {
      const group = item.etapaEnsino.codEtapaEnsino;
      if (!result[group]) {
        result[group] = [];
      }
      result[group].push(item);
      return result;
    }, {});

    Object.keys(agrupamentoPorEtapaEnsino).forEach(etapa => {
      const dadoTabela: DadosTabelaCargaHoraria = {
        etapa: this.catalogoEtapa[etapa],
        medias: [],
        pqr: [],
        turnos: []
      };

      const valoresPorEtapa = agrupamentoPorEtapaEnsino[etapa];
      valoresPorEtapa.forEach((element: any) => {
        dadoTabela.pqr.push(element.qntCargaHorariaDiaria);
        dadoTabela.turnos.push(element.tipoTurno);
      });

      this.dadosTabelaViewModel.push(dadoTabela);
    });
  }
}
